import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'footerLink',
    standalone: true
})
export class FooterLinkPipe implements PipeTransform {
  transform(
    slug: string,
    currentLang: string
  ): string {
    if(currentLang === 'de') {
      return 'https://www.bmw-welt.com/de' + slug;
    }
    return 'https://www.bmw-welt.com/en' + slug;
  }
}
